<template>
  <div class="home-container">
    <div class="hx-breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>首页</el-breadcrumb-item>
        <el-breadcrumb-item>场馆监管系统</el-breadcrumb-item>
        <el-breadcrumb-item>游泳馆</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ name: 'swimmingManagement' }"
          >游泳馆管理</el-breadcrumb-item
        >
        <el-breadcrumb-item>场馆详情</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="hx-form-container box-shadow">
      <div style="width: 60%; margin: auto;">
        <el-form
          v-loading="formLoading"
          ref="stadiumForm"
          :model="listParams"
          label-width="150px"
        >
          <el-form-item label="场馆名称：" prop="stadiumName">{{
            listParams.stadiumName
          }}</el-form-item>

          <el-form-item label="场馆地址：" prop="stadiumAddress">{{
            listParams.stadiumAddress
          }}</el-form-item>

          <el-form-item label="联系电话：" prop="mobile">{{
            listParams.mobile
          }}</el-form-item>

          <el-form-item label="场馆图片：" prop="stadiumImgs">
            <div
              class="wrap-thumbnail-img"
              v-if="listParams.stadiumImgs.length > 0"
            >
              <div
                class="thumbnail-img"
                v-for="(item, index) in listParams.stadiumImgs"
                :key="index"
              >
                <div class="combined-img">
                  <img
                    :src="item"
                    alt=""
                    class="thumbnail-img-wrapped"
                    :key="index"
                  />
                </div>
              </div>
            </div>
          </el-form-item>

          <el-form-item label="营业时间：" prop="businessTime">
            <div v-for="(item, index) in listParams.businessTime" :key="index">
              Î
              <span v-for="(item1, index1) in item" :key="index1">
                <span>
                  {{ item[index1] }}
                  <span v-if="index1 % 2 === 0">至</span>
                </span>
              </span>
            </div>
          </el-form-item>

          <el-form-item label="场馆介绍：" prop="introduce">
            <p>{{ content }}</p>
          </el-form-item>

          <el-form-item label=" ">
            <div class="align-center">
              <el-button size="small" @click="backToListPage">
                返回
              </el-button>
            </div>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      formLoading: false,
      listParams: {
        stadiumName: "",
        stadiumAddress: "",
        mobile: "",
        stadiumImgs: [],
        businessTime: [],
        introduce: ""
      }
    };
  },

  computed: {
    content() {
      return this.listParams.introduce.replace(/<.*?>/gi, "");
    }
  },

  mounted() {
    this.loadDetailData(this.$route.query.id);
  },
  methods: {
    /**
     * 加载详情页数据
     */
    loadDetailData(id) {
      this.formLoading = true;
      this.$http({
        url: global.apiUrl + "/stadiumManage/detail?stadiumId=" + id,
        methods: "GET"
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            this.formLoading = false;
            const resData = res.body.data;
            for (const i in resData) {
              this.listParams[i] = resData[i];
            }
          } else {
            this.formLoading = false;

          }
        })
        .catch(err => {
          this.formLoading = false;

          console.error(err);
        });
    },
    /**
     * 返回场馆信息列表页
     */
    backToListPage() {
      this.$router.push({
        name: "swimmingManagement"
      });
    }
  }
};
</script>

<style lang="less" scoped>
.hx-form-container {
  .wang-editor-style {
    height: 600px;
    .wang-editor-body {
      height: 540px;
    }
  }
  .upload-thumbnail-img,
  .thumbnail-img {
    width: 100px;
    height: 50px;
    border: 1px solid #ebeef5;
    position: relative;
    overflow: hidden;
    margin-left: 10px;
    .upload-icon {
      font-size: 20px;
      display: inline-block;
      margin-top: 15px;
      margin-left: 40px;
    }
    .hidden-upload {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      opacity: 0;
      filter: alpha(opacity=0); //filter 过滤器   兼容IE678
      z-index: 2;
      cursor: pointer;
    }
    .thumbnail-img-wrapped {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      z-index: 1;
    }
    .combined-img {
      position: relative;
      width: 100px;
      height: 50px;
      .hover-img {
        position: absolute;
        width: 100%;
        height: 100%;
        left: 0;
        top: 0;
        z-index: 999;
        opacity: 0;
        .close-btn {
          font-size: 22px;
          color: #fff;
          position: absolute;
          left: 50%;
          margin-left: -11px;
          top: 50%;
          margin-top: -11px;
        }
      }
      .hover-img:hover {
        opacity: 1;
        cursor: pointer;
        background-color: rgba(0, 0, 0, 0.5);
      }
    }
  }
  .wrap-thumbnail-img {
    width: 100%;
    height: 50px;
    margin-top: 10px;
    display: flex;
  }
}
</style>
